<ul class="list-unstyled"><li v-for="item in elements" :key="item.pk">{{ item.bez }}</li></ul>